<script setup lang="ts">
import ChatInputBar from "@/components/Dialogues/Chat/ChatInputBar.vue";
import MsgMine from "@/views/ChatMessage/MsgMine.vue";
import MsgReply from "@/views/ChatMessage/MsgReply.vue";
import {
  chatList,
  chatStatus,
  stopAbort,
} from "@/views/Home/useData/module/chat";
import {
  pcChatScrollMixins,
  pcInitScrollParams,
  pcScrollStatus,
} from "@/views/Home/useData/module/chatScroll";

import { watch, computed, onMounted, onUnmounted } from "vue";

watch(
  chatList,
  () => {
    // console.log("chatList", chatList);
  },
  {
    immediate: true,
    deep: true,
  }
);

const isReplying = computed(() => {
  return chatStatus.isReplying;
});

onMounted(() => {
  pcInitScrollParams();
  const first = pcChatScrollMixins.mixins[0];
  const { mountedAction } = first;
  mountedAction();
});

onUnmounted(() => {
  const first = pcChatScrollMixins.mixins[0];
  const { destroyedAction } = first;
  destroyedAction();
});
</script>

<template>
  <div class="message-base">
    <div class="content">
      <div class="msg-list" id="chat_home_main">
        <div class="list">
          <div v-for="(msgItem, index) in chatList" :key="msgItem.id">
            <MsgMine :msgObj="msgItem" v-if="msgItem.role == 'user'" />
            <MsgReply
              :msgIndex="index"
              :msgObj="msgItem"
              v-else-if="msgItem.role == 'assistant'"
            />
          </div>
        </div>
      </div>
      <div class="input-bar">
        <div class="stop-btn" v-if="isReplying" @click="stopAbort">
          <el-icon :size="18"><CircleClose /></el-icon>
          停止生成
        </div>
        <ChatInputBar class="input-bar" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.message-base {
  width: 100%;
  height: 100%;
}

.content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;

  .input-bar {
    max-width: 760px;
    width: 100%;
    flex-shrink: 0;
    margin-top: 20px;
    position: relative;
    z-index: 0;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .stop-btn {
      margin-bottom: 10px;
      width: 90px;
      height: 30px;
      border-radius: 4px;
      border: 1px solid #ccc;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      cursor: pointer;
      gap: 4px;

      &:hover {
        background-color: #dbeafe;
      }
    }
  }

  .msg-list {
    width: 100%;
    height: 100%;
    flex: 1;
    overflow-y: auto;
    display: flex;
    align-items: center;
    justify-content: center;

    .list {
      max-width: 760px;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
